import React, { Component } from "react";
import { Paper, Grid, Checkbox, IconButton, Icon, MenuItem } from "@material-ui/core";
import DropdownDefault from "../../Layout/DropdownDefault";

// Entity ke basis pe trigger text return karta hai
const getTriggerText = (entityType, trigger) => {
    const triggerMap = {
        lead: {
            1: 'If a new Lead is created',
            2: 'If lead status is changed to',
            3: 'If lead is assigned to',
            4: 'If lead is new and status duration is more than',
            5: 'If lead is new and status inactive days is more than',
        },
        contact: {
            1: 'If a new Contact is created',
            2: 'If contact is created from Lead conversion',
            3: 'If contact type is changed to',
            4: 'If inactive days is more than',
        },
        company: {
            1: 'If a new Company is created',
            2: 'If contact type is changed to',
            3: 'If inactive days is more than',
        },
        opportunity: {
            1: 'If a new Opportunity is created',
            2: 'If opportunity stage is changed to',
            3: 'If opportunity pipeline is changed to',
            4: 'If opportunity status is changed to',
            5: 'If opportunity is assigned to',
            6: 'If opportunity is open and days in stage is more than',
            7: 'If opportunity is open and inactive days is more than',
            8: 'If opportunity is open and close date is within',
        },
        project: {
            1: 'If a new Project is created',
            2: 'If project status is changed to',
        },
    };

    const entityTriggers = triggerMap[entityType] || {};
    return entityTriggers[trigger] || 'N/A';
};

// taskdata array se task names extract karta hai
const getTaskNames = (taskdata) => {
    if (!taskdata || taskdata.length === 0) return 'N/A';

    // New format: array of objects with taskname key
    if (taskdata[0] && taskdata[0].taskname) {
        return taskdata.map(t => t.taskname).join(', ');
    }

    // Old format: array of arrays with fieldid
    if (Array.isArray(taskdata[0])) {
        return taskdata.map((taskArr) => {
            const nameField = taskArr.find(f => f.fieldid === '57');
            return nameField ? nameField.taskvalue : 'N/A';
        }).join(', ');
    }

    return 'N/A';
};

class TaskAutomationLead extends Component {
    render() {
        const { automationList = [], entityType = 'lead', onDelete } = this.props;

        if (automationList.length === 0) {
            return (
                <p className="text-mute ml-16">No automation found.</p>
            );
        }

        return (
            <React.Fragment>
                {automationList.map((item) => (
                    <Paper key={item.id} variant="outlined" square className="paper_bx">
                        <Grid container spacing={1}>
                            <Grid item className="automation_icon">
                                <Checkbox
                                    value="checkbox"
                                    color="secondary"
                                    inputProps={{ 'aria-label': 'checkbox' }}
                                />
                            </Grid>
                            <Grid item className="automation_details flex-auto">
                                <p>
                                    Automation name{' '}
                                    <span className="font-weight-semi">{item.name}</span>
                                </p>
                                <p>
                                    Trigger{' '}
                                    <span className="font-weight-semi">
                                        {getTriggerText(entityType, item.trigger)}
                                    </span>
                                </p>
                                <p>
                                    Task action{' '}
                                    <span className="font-weight-semi">
                                        then create a task named{' '}
                                        <strong>{getTaskNames(item.taskdata)}</strong>
                                    </span>
                                </p>
                            </Grid>
                        </Grid>
                        <DropdownDefault
                            menuButton={
                                <IconButton
                                    aria-label="More"
                                    aria-haspopup="true"
                                    className="list_action"
                                    size="small"
                                >
                                    <Icon>more_vert</Icon>
                                </IconButton>
                            }
                        >
                            {/* <MenuItem><Icon className="action_icon">edit</Icon> Edit</MenuItem> */}
                            <MenuItem onClick={() => onDelete && onDelete(item.id)}>
                                <Icon className="action_icon">delete</Icon> Delete
                            </MenuItem>
                        </DropdownDefault>
                    </Paper>
                ))}
            </React.Fragment>
        );
    }
}

export default TaskAutomationLead;
